// extracted by mini-css-extract-plugin
module.exports = {"icon":"LoaderCircleIcon_icon__vPnqg","rotation":"LoaderCircleIcon_rotation__wX7jg"};